// TODO: [RCOTA POC] Refactor or remove this file depending on how the PoC progresses
import React, { useEffect } from 'react';
import { CommercialKit } from '@realcommercial.com.au/commercial-kit';
import { createGlobalStyle } from 'styled-components';
import { getDefaultViewData } from '@realestate.com.au/iglu-data';
import ElitePlusCarouselComponent from '../homepage/components/elitePlusCarousel/ElitePlusCarouselComponent';
import { fetchLatestListings } from '../fetchData';
import type { ElitePlusCarouselListing } from '../homepage/model/elitePlusCarouselListingResponse';
import tealiumWrapper from '../../shared/tracking/tealium/tealiumWrapper';
import { constructUserData } from '../../shared/tracking/tealium/trackingUtils';

export type LatestListingsAppProps = {
  params: {
    data: {
      listings: ElitePlusCarouselListing[];
    };
  };
};

const GlobalReset = createGlobalStyle`
  @font-face {
    font-family: 'Times Classic';
    src: url('https://resourcesssl.newscdn.com.au/cs/ts2020/assets/fonts/TimesClassicDisplayW05-Bold.woff2') format('woff2');
    font-weight: bold;
    font-style: normal;
  }

  @font-face {
    font-family: 'Times Classic';
    src: url('https://resourcesssl.newscdn.com.au/cs/ts2020/assets/fonts/TimesClassicDisplayW05-Rg.woff2') format('woff2');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'Times Classic';
    src: url('https://resourcesssl.newscdn.com.au/cs/ts2020/assets/fonts/TimesClassicTextW05-Italic.woff2') format('woff2');
    font-weight: normal;
    font-style: italic;
  }

  @font-face {
    font-family: 'Times Classic';
    src: url('https://resourcesssl.newscdn.com.au/cs/ts2020/assets/fonts/TimesClassicTextW05-BoldIt.woff2') format('woff2');
    font-weight: bold;
    font-style: italic;
  }

  body {
    background-color: white;
  }

  body * {
    border-radius: 0 !important;
    font-family: 'Times Classic', serif !important;
  }
`;

const LatestListingsApp = ({ params }: LatestListingsAppProps) => {
  const {
    data: { listings },
  } = params;

  const listingsWithTrackingUrl = listings.map((listing: ElitePlusCarouselListing) => ({
    ...listing,
    pdpUrl: `${listing.pdpUrl}?campaignType=external&campaignSource=the-australian&campaignName=the-australian-suggested-properties-carousel&campaignChannel=display`,
  }));

  const embedCarouselViewData = {
    page: {
      pageName: 'rca:embedded:latest-listings-carousel',
      pageType: 'latest-listings-carousel',
      site: 'rca',
      siteSection: 'embedded',
    },
  };

  const handlePageTracking = () => {
    tealiumWrapper.trackView([...getDefaultViewData(embedCarouselViewData), constructUserData]);
    window.RCA = window.RCA || {};
  };

  useEffect(() => {
    handlePageTracking();
  }, []);

  return (
    <CommercialKit>
      <GlobalReset />
      <ElitePlusCarouselComponent listings={listingsWithTrackingUrl} bucket="featured" isEmbed />
    </CommercialKit>
  );
};

LatestListingsApp.fetchData = () => fetchLatestListings;

export default LatestListingsApp;
